module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "clock.590229c4.png";